import { IUserGroup } from '@models/UserGroup.model';
import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';

export interface IProfile {
  id: string;
  name: string;
  email: string;
  auth0Id: string;
  avatar: string;
  userGroupId: string;
  avatarUri: string;
  userGroup: IUserGroup;
  createdAt: Date;
  updatedAt: Date;
  role: string;
  isSuperAdmin: boolean;
}

export interface IProfileApiModel {
  id: string;
  name: string;
  email: string;
  auth0Id: string;
  avatar: string;
  userGroupId: string;
  avatarUri: string;
  userGroup: IUserGroup;
  createdAt: string;
  updatedAt: string;
  role: string;
  isSuperAdmin: boolean;
}

export default class Profile implements IProfile {
  public readonly id: string;

  public readonly name: string;

  public readonly email: string;

  public readonly auth0Id: string;

  public readonly avatar: string;

  public readonly avatarUri: string;

  public readonly userGroupId: string;

  public readonly userGroup: IUserGroup;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  public readonly role: string;

  public readonly isSuperAdmin: boolean;

  constructor(
    id: string,
    name: string,
    email: string,
    auth0Id: string,
    avatar: string,
    avatarUri: string,
    userGroupId: string,
    userGroup: IUserGroup,
    createdAt: Date,
    updatedAt: Date,
    role: string,
    isSuperAdmin: boolean,
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.auth0Id = auth0Id;
    this.avatar = avatar;
    this.userGroupId = userGroupId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.userGroup = userGroup;
    this.avatarUri = avatarUri;
    this.role = role;
    this.isSuperAdmin = isSuperAdmin;
  }

  static fromApiModel(apiModel: IProfileApiModel) {
    const {
      id,
      name,
      email,
      auth0Id,
      userGroup,
      userGroupId,
      role,
      isSuperAdmin,
    } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));
    const avatar = updateBeamUrl(apiModel.avatar);
    const avatarUri = updateBeamUrl(apiModel.avatarUri);

    return new Profile(
      id,
      name,
      email,
      auth0Id,
      avatar,
      avatarUri,
      userGroupId,
      userGroup,
      createdAt,
      updatedAt,
      role,
      isSuperAdmin,
    );
  }
}
